// import React, { useState, useCallback } from 'react';
// import { ArrowRight } from 'lucide-react';
// import { Link } from 'react-router-dom';

// // Perfect Spin Wheel Component
// const PerfectSpinWheel = ({ isDesktop = false }) => {
//   const [isSpinning, setIsSpinning] = useState(false);
//   const [rotation, setRotation] = useState(0);
//   const [winner, setWinner] = useState(null);
//   const [showConfetti, setShowConfetti] = useState(false);

//   const segments = [
//     { id: 1, text: "₹500", subText: "Voucher", color: "#3B82F6", textColor: "#fff" },
//     { id: 2, text: "30% OFF", subText: "Skincare", color: "#8B5CF6", textColor: "#fff" },
//     { id: 3, text: "₹100", subText: "Cashback", color: "#10B981", textColor: "#fff" },
//     { id: 4, text: "Free", subText: "Shipping", color: "#F59E0B", textColor: "#fff" },
//     { id: 5, text: "50% OFF", subText: "Beauty", color: "#EF4444", textColor: "#fff" },
//     { id: 6, text: "₹200", subText: "Discount", color: "#EC4899", textColor: "#fff" },
//     { id: 7, text: "Buy 1", subText: "Get 1 Free", color: "#06B6D4", textColor: "#fff" },
//     { id: 8, text: "Try Again", subText: "Next Time", color: "#6B7280", textColor: "#fff" }
//   ];

//   const spinWheel = () => {
//     if (isSpinning) return;
    
//     setIsSpinning(true);
//     setWinner(null);
//     setShowConfetti(false);
    
//     const minSpins = 5;
//     const maxSpins = 8;
//     const spins = minSpins + Math.random() * (maxSpins - minSpins);
//     const finalAngle = Math.random() * 360;
//     const totalRotation = rotation + (spins * 360) + finalAngle;
    
//     setRotation(totalRotation);
    
//     setTimeout(() => {
//       const normalizedAngle = (totalRotation % 360);
//       const segmentAngle = 45; // 360/8 segments
//       const adjustedAngle = (90 - normalizedAngle + 360) % 360; // Adjust for pointer at top
//       const segmentIndex = Math.floor(adjustedAngle / segmentAngle);
//       const winningSegment = segments[segmentIndex] || segments[0];
      
//       setWinner(winningSegment);
//       setIsSpinning(false);
//       console.log({
//         rotation,
//         normalizedAngle,
//         adjustedAngle,
//         segmentIndex,
//         winner: segments[segmentIndex]
//       });
//       if (winningSegment.text !== "Try Again") {
//         setShowConfetti(true);
//         setTimeout(() => setShowConfetti(false), 3000);
//       }
//     }, 4000);
//   };

//   const resetWheel = () => {
//     setWinner(null);
//     setIsSpinning(false);
//     setShowConfetti(false);
//   };

//   const claimPrize = () => {
//     alert(`🎉 Congratulations! You've won: ${winner.text} ${winner.subText}!`);
//     resetWheel();
//   };

//   const wheelSize = isDesktop ? 200 :150;
//   const centerSize = isDesktop ? 20 : 30;

//   return (
//     <div className="h-96 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4 relative overflow-hidden">
//         <div 
//   className="absolute inset-0 opacity-30"
//   style={{
//     backgroundImage: `url('/assets/spin.jpeg')`,
//     backgroundSize: 'cover',
//     backgroundPosition: 'center'
//   }}></div>
//       {/* Confetti Animation */}
//       {showConfetti && (
//         <div className="fixed inset-0 pointer-events-none z-50">
//           {[...Array(30)].map((_, i) => (
//             <div
//               key={i}
//               className="absolute w-2 h-2 rounded-full animate-bounce"
//               style={{
//                 backgroundColor: segments[i % segments.length].color,
//                 left: `${Math.random() * 100}%`,
//                 top: `${Math.random() * 100}%`,
//                 animationDelay: `${Math.random() * 2}s`,
//                 animationDuration: `${2 + Math.random() * 2}s`
//               }}
//             />
//           ))}
//         </div>
//       )}

//       <div className="relative z-10 text-center">
//         {/* Header */}
//         <div className="mb-0">
         
          
//           <h1 className={`${isDesktop ? 'text-md' : 'text-2xl mb-2'} font-serif font-bold text-white  drop-shadow-lg`}>
//             SPIN TO WIN 
//           </h1>
//           <p className={`${isDesktop ? 'text-sm' : 'text-sm mb-1'}font-serif text-white opacity-90`}>
//             Try your luck and win amazing prizes!
//           </p>
//         </div>

//         {/* Wheel Container */}
//         <div className="relative inline-block mb-1 mt-2">
//           {/* Wheel Shadow */}
//           <div 
//             className="absolute top-2 left-2 rounded-full bg-black opacity-30 blur-lg"
//             style={{ width: wheelSize, height: wheelSize }}
//           />
          
//           {/* Outer Orange Ring */}
//           <div 
//             className="rounded-full bg-gradient-to-br from-orange-400 to-orange-500 shadow-2xl relative"
//             style={{ width: wheelSize + 20, height: wheelSize + 20 }}
//           >
//             {/* White Dots Around the Ring */}
//             {[...Array(16)].map((_, i) => (
//               <div
//                 key={i}
//                 className="absolute w-3 h-3 bg-white rounded-full shadow-sm"
//                 style={{
//                   top: '8px',
//                   left: '50%',
//                   transform: `translateX(-50%) rotate(${i * 22.5}deg) translateY(6px)`,
//                   transformOrigin: `50% ${(wheelSize + 20 - 16) / 2}px`
//                 }}
//               />
//             ))}
            
//             {/* Main Wheel */}
//             <div
//               className="absolute top-2.5 left-2.5 w-full h-full rounded-full overflow-hidden transition-transform ease-out"
//               style={{
//                 width: wheelSize,
//                 height: wheelSize,
//                 transform: `rotate(${rotation}deg)`,
//                 transitionDuration: isSpinning ? '4000ms' : '0ms',
//                 transitionTimingFunction: isSpinning ? 'cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'ease'
//               }}
//             >
//               <svg 
//                 width={wheelSize} 
//                 height={wheelSize} 
//                 className="absolute inset-0"
//                 viewBox={`0 0 ${wheelSize} ${wheelSize}`}
//               >
//                 {segments.map((segment, index) => {
//                   const centerX = wheelSize / 2;
//                   const centerY = wheelSize / 2;
//                   const radius = wheelSize / 2 - 5;
//                   const segmentAngle = 45; // 360/8 segments
//                   const startAngle = index * segmentAngle;
//                   const endAngle = (index + 1) * segmentAngle;
//                   const midAngle = startAngle + segmentAngle / 2;
                  
//                   // Calculate path coordinates
//                   const x1 = centerX + radius * Math.cos((startAngle * Math.PI) / 180);
//                   const y1 = centerY + radius * Math.sin((startAngle * Math.PI) / 180);
//                   const x2 = centerX + radius * Math.cos((endAngle * Math.PI) / 180);
//                   const y2 = centerY + radius * Math.sin((endAngle * Math.PI) / 180);
                  
//                   // Text positioning
//                   const textRadius = radius * 0.65;
//                   const textX = centerX + textRadius * Math.cos((midAngle * Math.PI) / 180);
//                   const textY = centerY + textRadius * Math.sin((midAngle * Math.PI) / 180);
                  
//                   return (
//                     <g key={segment.id}>
//                       {/* Segment Background */}
//                       <path
//                         d={`M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 0 1 ${x2} ${y2} Z`}
//                         fill={segment.color}
//                         stroke="#fff"
//                         strokeWidth="2"
//                       />
                      
//                       {/* Main Text */}
//                       <text
//                         x={textX}
//                         y={textY - 3}
//                         textAnchor="middle"
//                         dominantBaseline="middle"
//                         fill={segment.textColor}
//                         fontSize={isDesktop ? "10" : "8"}
//                         fontWeight="medium"
//                         transform={`rotate(${midAngle + 90}, ${textX}, ${textY})`}
//                       >
//                         {segment.text}
//                       </text>
                      
//                       {/* Sub Text */}
//                       <text
//                         x={textX}
//                         y={textY + 10}
//                         textAnchor="middle"
//                         dominantBaseline="middle"
//                         fill={segment.textColor}
//                         fontSize={isDesktop ? "8" : "6"}
//                         fontWeight="500"
//                         transform={`rotate(${midAngle + 90}, ${textX}, ${textY})`}
//                       >
//                         {segment.subText}
//                       </text>
//                     </g>
//                   );
//                 })}
//               </svg>
              
//               {/* Center Circle */}
//               <div 
//                 className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gradient-to-br from-orange-400 to-orange-500 rounded-full shadow-lg border-4 border-white flex items-center justify-center"
//                 style={{ width: centerSize, height: centerSize }}
//               >
//                 <div className="w-6 h-6 bg-gradient-to-br from-red-500 to-red-600 rounded-full flex items-center justify-center">
//                   <span className="text-white font-bold text-sm">⭐</span>
//                 </div>
//               </div>
//             </div>
            
//             {/* Pointer */}
//             <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1 z-20">
//               <div className="w-0 h-0 border-l-4 border-r-4 border-b-8 border-l-transparent border-r-transparent border-b-red-500 drop-shadow-lg"></div>
//               <div className="absolute top-2 left-1/2 transform -translate-x-1/2 w-4 h-4 bg-red-500 rounded-full border-2 border-white shadow-lg"></div>
//             </div>
//           </div>
//         </div>

//         {/* Controls */}
//         {!isSpinning && !winner && (
//           <div className="space-y-1 font-serif">
//             <button
//               onClick={spinWheel}
//               className={`bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-400 hover:to-red-400 text-white font-bold ${isDesktop ? 'py-1 px-1 text-sm' : 'py-1 px-1 text-sm'} rounded-full transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-xl`}
//             >
//               🎰 SPIN THE WHEEL 🎰
//             </button>
//             <p className={`${isDesktop ? 'text-base' : 'text-sm'} font-serif text-white opacity-80 font-serif`}>
//               Click to spin and win amazing prizes!
//             </p>
//           </div>
//         )}

//         {/* Spinning Animation */}
//         {isSpinning && (
//           <div className="space-y-1">
//             <div className={`${isDesktop ? 'text-xl' : 'text-lg'} font-bold text-white animate-pulse`}>
//               🌟 SPINNING... 🌟
//             </div>
//             <div className="flex justify-center space-x-1">
//               {[...Array(3)].map((_, i) => (
//                 <div
//                   key={i}
//                   className="w-3 h-3 bg-white rounded-full animate-bounce"
//                   style={{ animationDelay: `${i * 0.2}s` }}
//                 />
//               ))}
//             </div>
//             <p className={`${isDesktop ? 'text-base' : 'text-base'} text-white opacity-80`}>
//               Good luck! 🍀
//             </p>
//           </div>
//         )}

//         {/* Winner Display */}
//         {winner && !isSpinning && (
//           <div className="animate-fadeIn font-serif">
//             <div className="bg-white bg-opacity-20 backdrop-blur-lg rounded-xl p-2 shadow-2xl border border-white border-opacity-30 relative max-w-sm mx-auto">
//               <button
//                 onClick={resetWheel}
//                 className="absolute top-2 right-2 w-7 h-7 bg-red-500 hover:bg-red-600 text-white rounded-full flex items-center justify-center transition-all duration-300 text-sm"
//               >
//                 ✕
//               </button>
// {/*               
//               <div className="text-sm ">
//                 {winner.text === "Try Again" ? "🌟" : "🎉"}
//               </div> */}
              
//               <h2 className={`${isDesktop ? 'text-sm' : 'text-sm'} font-semibold text-white `}>
//                 {winner.text === "Try Again" ? "Almost There!" : "CONGRATULATIONS!"}
//               </h2>
              
//               {winner.text !== "Try Again" ? (
//                 <div className="space-y-1">
//                   <div
//                     className="inline-block px-1  rounded-full text-white font-bold shadow-lg"
//                     style={{ backgroundColor: winner.color }}
//                   >
//                     {winner.text} {winner.subText}
//                   </div>
//                   {/* <p className="text-white text-sm opacity-90 font-serif">
//                     Your prize is ready!
//                   </p> */}
//                 </div>
//               ) : (
//                 <div className="space-y-1">
//                   <p className="text-white text-sm opacity-90 font-serif">
//                     Try again for better luck!
//                   </p>
//                 </div>
//               )}
              
//               <div className="flex gap-2 justify-center mt-1 font-serif">
//                 <button
//                   onClick={resetWheel}
//                   className="bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-400 hover:to-purple-400 text-white font-bold py-1 px-1 rounded-full transition-all duration-300 text-sm"
//                 >
//                   Spin Again
//                 </button>
//                 {winner.text !== "Try Again" && (
//                   <button
//                     onClick={claimPrize}
//                     className="bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-400 hover:to-emerald-400 text-white font-bold py-1 px-1 rounded-full transition-all duration-300 text-sm"
//                   >
//                     Claim Prize
//                   </button>
//                 )}
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       <style jsx>{`
//         @keyframes fadeIn {
//           from { opacity: 0; transform: translateY(20px); }
//           to { opacity: 1; transform: translateY(0); }
//         }
//         .animate-fadeIn {
//           animation: fadeIn 0.6s ease-out;
//         }
//       `}</style>
//     </div>
//   );
// };


import React, { useState, useCallback } from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
// Perfect Spin Wheel Component
const PerfectSpinWheel = ({ isDesktop = false }) => {
  const [isSpinning, setIsSpinning] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [winner, setWinner] = useState(null);
  const [showConfetti, setShowConfetti] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const segments = [
    { id: 1, text: "₹500", subText: "Voucher", color: "#3B82F6", textColor: "#fff" },
    { id: 2, text: "30% OFF", subText: "Skincare", color: "#8B5CF6", textColor: "#fff" },
    { id: 3, text: "₹100", subText: "Cashback", color: "#10B981", textColor: "#fff" },
    { id: 4, text: "Free", subText: "Shipping", color: "#F59E0B", textColor: "#fff" },
    { id: 5, text: "50% OFF", subText: "Beauty", color: "#EF4444", textColor: "#fff" },
    { id: 6, text: "₹200", subText: "Discount", color: "#EC4899", textColor: "#fff" },
    { id: 7, text: "Buy 1", subText: "Get 1 Free", color: "#06B6D4", textColor: "#fff" },
    { id: 8, text: "Try Again", subText: "Next Time", color: "#6B7280", textColor: "#fff" }
  ];

  const spinWheel = () => {
    if (isSpinning) return;
    
    setIsSpinning(true);
    setWinner(null);
    setShowConfetti(false);
    setShowModal(false);
    
    const minSpins = 5;
    const maxSpins = 8;
    const spins = minSpins + Math.random() * (maxSpins - minSpins);
    const finalAngle = Math.random() * 360;
    const totalRotation = rotation + (spins * 360) + finalAngle;
    
    setRotation(totalRotation);
    
    setTimeout(() => {
      const normalizedAngle = (totalRotation % 360);
      const segmentAngle = 45; // 360/8 segments
      const adjustedAngle = (90 - normalizedAngle + 360) % 360; // Adjust for pointer at top
      const segmentIndex = Math.floor(adjustedAngle / segmentAngle);
      const winningSegment = segments[segmentIndex] || segments[0];
      
      setWinner(winningSegment);
      setIsSpinning(false);
      setShowModal(true);
      
      if (winningSegment.text !== "Try Again") {
        setShowConfetti(true);
        setTimeout(() => setShowConfetti(false), 3000);
      }
    }, 4000);
  };

  const resetWheel = () => {
    setWinner(null);
    setIsSpinning(false);
    setShowConfetti(false);
    setShowModal(false);
  };

  const claimPrize = () => {
    alert(`🎉 Congratulations! You've won: ${winner.text} ${winner.subText}!`);
    resetWheel();
  };

  const wheelSize = isDesktop ? 200 : 150;
  const centerSize = isDesktop ? 20 : 30;

  return (
    <div className="h-96 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4 relative overflow-hidden">
      <div 
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage: `url('/assets/spin.jpeg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      />
      
      {/* Confetti Animation */}
      {showConfetti && (
        <div className="absolute inset-0 pointer-events-none z-40">
          {[...Array(30)].map((_, i) => (
            <div
              key={i}
              className="absolute w-2 h-2 rounded-full animate-bounce"
              style={{
                backgroundColor: segments[i % segments.length].color,
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 2}s`,
                animationDuration: `${2 + Math.random() * 2}s`
              }}
            />
          ))}
        </div>
      )}

      {/* Modal Overlay - Fixed positioning within the component */}
      {showModal && winner && (
        <div className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="relative bg-white bg-opacity-10 backdrop-blur-xl rounded-2xl shadow-2xl max-w-xs w-full mx-4 pt-6 pb-4 px-4 animate-fadeIn">
            
            <button
              onClick={resetWheel}
              className="absolute top-2 right-2 w-8 h-8 bg-white bg-opacity-40 hover:bg-opacity-60 text-gray-800 font-bold rounded-full flex items-center justify-center transition duration-300"
            >
              ✕
            </button>

            <div className="text-5xl text-center mb-2">
              {winner.text === "Try Again" ? "😔" : "🎉"}
            </div>

            <h2 className="text-xl font-extrabold text-center text-white mb-1">
              {winner.text === "Try Again" ? "Almost There!" : "Congratulations!"}
            </h2>

            <p className="text-sm text-white text-opacity-80 text-center mb-2">
              {winner.text === "Try Again" ? "Better luck next time!" : "You won:"}
            </p>

            {winner.text !== "Try Again" && (
              <div
                className="mx-auto text-center text-white font-bold text-base px-6 py-2 rounded-full mb-2 shadow-md"
                style={{ backgroundColor: winner.color }}
              >
                {winner.text}
              </div>
            )}

            <p className="text-sm text-white text-opacity-80 text-center mb-4">
              {winner.subText}
            </p>

            <div className="flex justify-center items-center gap-3 mt-4">
              {winner.text !== "Try Again" && (
                <button
                  onClick={claimPrize}
                  className="whitespace-nowrap px-6 py-2 rounded-full bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-400 hover:to-red-400 text-white text-sm font-semibold shadow-md transition-transform duration-300 hover:scale-105"
                >
                  Claim Prize
                </button>
              )}
              <button
                onClick={resetWheel}
                className="whitespace-nowrap px-6 py-2 rounded-full bg-gradient-to-r from-gray-500 to-gray-600 hover:from-gray-400 hover:to-gray-500 text-white text-sm font-semibold shadow-md transition-transform duration-300 hover:scale-105"
              >
                Spin Again
              </button>
            </div>

          </div>
        </div>
      )}

      <div className="relative z-10 text-center">
        {/* Header */}
        <div className="mb-0">
          <h1 className={`${isDesktop ? 'text-md' : 'text-2xl mb-2'} font-serif font-bold text-white drop-shadow-lg`}>
            SPIN TO WIN 
          </h1>
          <p className={`${isDesktop ? 'text-sm' : 'text-sm mb-1'} font-serif text-white opacity-90`}>
            Try your luck and win amazing prizes!
          </p>
        </div>

        {/* Wheel Container */}
        <div className="relative inline-block mb-1 mt-2">
          {/* Wheel Shadow */}
          <div 
            className="absolute top-2 left-2 rounded-full bg-black opacity-30 blur-lg"
            style={{ width: wheelSize, height: wheelSize }}
          />
          
          {/* Outer Orange Ring */}
          <div 
            className="rounded-full bg-gradient-to-br from-orange-400 to-orange-500 shadow-2xl relative"
            style={{ width: wheelSize + 20, height: wheelSize + 20 }}
          >
            {/* White Dots Around the Ring */}
            {[...Array(16)].map((_, i) => (
              <div
                key={i}
                className="absolute w-3 h-3 bg-white rounded-full shadow-sm"
                style={{
                  top: '8px',
                  left: '50%',
                  transform: `translateX(-50%) rotate(${i * 22.5}deg) translateY(6px)`,
                  transformOrigin: `50% ${(wheelSize + 20 - 16) / 2}px`
                }}
              />
            ))}
            
            {/* Main Wheel */}
            <div
              className="absolute top-2.5 left-2.5 w-full h-full rounded-full overflow-hidden transition-transform ease-out"
              style={{
                width: wheelSize,
                height: wheelSize,
                transform: `rotate(${rotation}deg)`,
                transitionDuration: isSpinning ? '4000ms' : '0ms',
                transitionTimingFunction: isSpinning ? 'cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'ease'
              }}
            >
              <svg 
                width={wheelSize} 
                height={wheelSize} 
                className="absolute inset-0"
                viewBox={`0 0 ${wheelSize} ${wheelSize}`}
              >
                {segments.map((segment, index) => {
                  const centerX = wheelSize / 2;
                  const centerY = wheelSize / 2;
                  const radius = wheelSize / 2 - 5;
                  const segmentAngle = 45; // 360/8 segments
                  const startAngle = index * segmentAngle;
                  const endAngle = (index + 1) * segmentAngle;
                  const midAngle = startAngle + segmentAngle / 2;
                  
                  // Calculate path coordinates
                  const x1 = centerX + radius * Math.cos((startAngle * Math.PI) / 180);
                  const y1 = centerY + radius * Math.sin((startAngle * Math.PI) / 180);
                  const x2 = centerX + radius * Math.cos((endAngle * Math.PI) / 180);
                  const y2 = centerY + radius * Math.sin((endAngle * Math.PI) / 180);
                  
                  // Text positioning
                  const textRadius = radius * 0.65;
                  const textX = centerX + textRadius * Math.cos((midAngle * Math.PI) / 180);
                  const textY = centerY + textRadius * Math.sin((midAngle * Math.PI) / 180);
                  
                  return (
                    <g key={segment.id}>
                      {/* Segment Background */}
                      <path
                        d={`M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 0 1 ${x2} ${y2} Z`}
                        fill={segment.color}
                        stroke="#fff"
                        strokeWidth="2"
                      />
                      
                      {/* Main Text */}
                      <text
                        x={textX}
                        y={textY - 3}
                        textAnchor="middle"
                        dominantBaseline="middle"
                        fill={segment.textColor}
                        fontSize={isDesktop ? "10" : "8"}
                        fontWeight="medium"
                        transform={`rotate(${midAngle + 90}, ${textX}, ${textY})`}
                      >
                        {segment.text}
                      </text>
                      
                      {/* Sub Text */}
                      <text
                        x={textX}
                        y={textY + 10}
                        textAnchor="middle"
                        dominantBaseline="middle"
                        fill={segment.textColor}
                        fontSize={isDesktop ? "8" : "6"}
                        fontWeight="500"
                        transform={`rotate(${midAngle + 90}, ${textX}, ${textY})`}
                      >
                        {segment.subText}
                      </text>
                    </g>
                  );
                })}
              </svg>
              
              {/* Center Circle */}
              <div 
                className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gradient-to-br from-orange-400 to-orange-500 rounded-full shadow-lg border-4 border-white flex items-center justify-center"
                style={{ width: centerSize, height: centerSize }}
              >
                <div className="w-6 h-6 bg-gradient-to-br from-red-500 to-red-600 rounded-full flex items-center justify-center">
                  <span className="text-white font-bold text-sm">⭐</span>
                </div>
              </div>
            </div>
            
            {/* Pointer */}
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1 z-20">
              <div className="w-0 h-0 border-l-4 border-r-4 border-b-8 border-l-transparent border-r-transparent border-b-red-500 drop-shadow-lg"></div>
              <div className="absolute top-2 left-1/2 transform -translate-x-1/2 w-4 h-4 bg-red-500 rounded-full border-2 border-white shadow-lg"></div>
            </div>
          </div>
        </div>

        {/* Controls */}
        {!isSpinning && (
          <div className="space-y-1 font-serif">
            <button
              onClick={spinWheel}
              className={`bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-400 hover:to-red-400 text-white font-bold ${isDesktop ? 'py-1 px-1 text-sm' : 'py-1 px-1 text-sm'} rounded-full transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-xl`}
            >
              🎰 SPIN THE WHEEL 🎰
            </button>
            <p className={`${isDesktop ? 'text-base' : 'text-sm'} font-serif text-white opacity-80 font-serif`}>
              Click to spin and win amazing prizes!
            </p>
          </div>
        )}

        {/* Spinning Animation */}
        {isSpinning && (
          <div className="space-y-1">
            <div className={`${isDesktop ? 'text-xl' : 'text-lg'} font-bold text-white animate-pulse`}>
              🌟 SPINNING... 🌟
            </div>
            <div className="flex justify-center space-x-1">
              {[...Array(3)].map((_, i) => (
                <div
                  key={i}
                  className="w-3 h-3 bg-white rounded-full animate-bounce"
                  style={{ animationDelay: `${i * 0.2}s` }}
                />
              ))}
            </div>
            <p className={`${isDesktop ? 'text-base' : 'text-base'} text-white opacity-80`}>
              Good luck! 🍀
            </p>
          </div>
        )}
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px) scale(0.9); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};


function App() {
  const [isMobile, setIsMobile] = useState(true);

  return (
    <>

      <Helmet>
       <title>
       Mamaearth Campaign | Spin the Wheel Ad Showcase by Bidbox
        </title>
        <meta
          name="description"
          content="Discover how Mamaearth runs Spin the Wheel ads with Bidbox. Explore fun, interactive campaigns that drive engagement & delight customers."
        />
        {/* <meta
          name="keywords"
          content="Discover how Recard campaigns run in CTV Quiz ads. Explore Bidbox’s creative retargeting strategies that boost engagement & conversions."
        /> */}
         <link
          rel="canonical"
          href="https://bidbox.ai/spin-the-wheel/mamaearth"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
    </Helmet>
    <div className="min-h-screen bg-gray-50 mt-10">
      <div className="container mx-auto px-8 py-8 lg:py-12">
        <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
          {/* Left column - Content */}
          <div className="flex-1 lg:max-w-lg">
            {/* Header */}
            <header className="animate-slide-up">
              {/* Title and tag */}
              <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
                <div className="flex flex-wrap items-center gap-3 mb-3">
                  <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                  Spin It. Win Big. Repeat.
                  </h1>
                  <span className="bg-orange-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                  Spin the wheel
                  </span>
                </div>
              </div>
            </header>

            {/* Content Section */}
            <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
              {/* Make it yours section */}
              <div className="mb-8">
                <h2 className="text-lg font-bold text-orange-600 mb-4 tracking-wide">
                BOOST INTERACTION INSTANTLY
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
                This spin-to-win experience turns user curiosity into instant engagement. With a vibrant wheel, surprise prizes, and playful animations, it’s perfect for promotions, giveaways, or loyalty rewards. Just add your brand, prizes, and styling to launch a game that entertains while it converts.
                </p>
                
                {/* CTA Button */}
                <Link to='/contact'>
                <button className="group bg-white border-2 border-orange-500 text-orange-500 px-6 py-3 rounded-full font-medium hover:bg-orange-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
                  <span>Start with this Template</span>
                  <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
                </button>
                </Link>
              </div>
            </div>
          </div>

          {/* Right column - Template Preview */}
          <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
            {/* Preview toggle */}
            <div className="hidden lg:flex justify-center mt-2 animate-fade-in mb-4" style={{ animationDelay: '0.3s' }}>
                <div className="bg-white rounded-full px-6 py-3 shadow-lg border border-gray-200">
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center space-x-3">
                      <span className={`text-sm font-medium transition-colors ${isMobile ? 'text-orange-600' : 'text-gray-600'}`}>
                        Mobile
                      </span>
                      <button
                        onClick={() => setIsMobile(!isMobile)}
                        className="relative w-12 h-6 bg-orange-500 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
                      >
                        <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 ${isMobile ? 'left-1' : 'left-7'}`}></div>
                      </button>
                      <span className={`text-sm font-medium transition-colors ${!isMobile ? 'text-orange-600' : 'text-gray-600'}`}>
                        Desktop
                      </span>
                    </div>
                  </div>
                </div>
              </div>
           
            <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
              
              {/* Mobile Mockup */}
              {isMobile && (
                <div className="mx-auto max-w-xs">
                  {/* iPhone mockup */}
                  <div className="relative bg-gray-200 rounded-[2.5rem] p-2 shadow-2xl">
                    {/* Status bar area */}
                    <div className="bg-white rounded-[2rem] overflow-hidden">
                      {/* Status bar */}
                      <div className="bg-white px-6 py-2 flex justify-between items-center text-black text-sm font-medium">
                        <span>9:41</span>
                        <div className="flex items-center space-x-1">
                          <div className="flex space-x-1">
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                          </div>
                          <div className="w-6 h-3 border border-black rounded-sm relative">
                            <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
                          </div>
                        </div>
                      </div>

                      {/* Browser bar */}
                      <div className="bg-gray-100 px-4 py-3 flex items-center space-x-3">
                        <div className="flex-1 bg-white rounded-lg px-3 py-2 text-sm text-gray-600 flex items-center justify-center">
                          spin-to-win.com
                        </div>
                      </div>

                      {/* Content area */}
                      <div className="p-4 bg-gray-50 h-[400px] overflow-y-auto hide-scrollbar">
                        {/* Spin Wheel - Full screen on mobile */}
                        <div className="space-y-3">
                    <div className="h-3 bg-gray-200 rounded w-full"></div>
                    <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                    <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                  </div>
                  
                  <div className="mb-6">
                  <div className="relative group transform transition-all duration-300 rounded-lg overflow-hidden">
                          <PerfectSpinWheel isDesktop={false} />
                        </div>
                        </div>
                        <div className="space-y-3">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Desktop Mockup */}
              {!isMobile && (
                <div className="w-full max-w-4xl mx-auto hidden lg:block">
                  {/* Desktop Screen Frame */}
                  <div className="bg-gray-200 rounded-xl p-3 shadow-2xl">
                    {/* Screen */}
                    <div className="bg-white rounded-lg overflow-hidden shadow-inner" style={{ aspectRatio: '16/10' }}>
                      {/* macOS-style window header */}
                      <div className="bg-gray-100 px-4 py-3 flex items-center border-b border-gray-200">
                        <div className="flex space-x-2">
                          <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                          <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                          <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                        </div>
                        <div className="flex-1 mx-2">
                          <div className="bg-white rounded-md px-2 py-1 text-sm text-gray-600 border shadow-sm max-w-md">
                            🔒 spin-to-win.com
                          </div>
                        </div>
                        <div className="flex space-x-2">
                          <div className="w-4 h-4 bg-gray-300 rounded"></div>
                          <div className="w-4 h-4 bg-gray-300 rounded"></div>
                        </div>
                      </div>

                      {/* Browser content area */}
                      <div className="bg-gray-50 h-[500px] overflow-y-auto hide-scrollbar">
                        {/* Spin Wheel centered on desktop */}
                        <div className="mb-2">
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>

                          </div>
                        <div className="flex justify-center ">
                          <div className="w-full max-w-md ">
                            <PerfectSpinWheel isDesktop={true} />
                          </div>
                        </div>
                         {/* Additional content placeholders */}
                         <div className="grid grid-cols-2 gap-6 mb-6 mt-2">
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                            <div className="space-y-3 mt-2">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                          </div>

                          {/* Sidebar placeholders */}
                          <div className="grid grid-cols-3 gap-4">
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                          </div>
                          <div className="grid grid-cols-2 gap-6 mb-6">
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                        </div>

                        {/* Sidebar placeholders */}
                        <div className="grid grid-cols-3 gap-4">
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Monitor stand */}
                  <div className="flex justify-center">
                    <div className="w-20 h-4 bg-gray-200 rounded-b-lg"></div>
                  </div>
                  <div className="flex justify-center">
                    <div className="w-32 h-2 bg-gray-300 rounded-full"></div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes slide-up {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .animate-slide-up {
          animation: slide-up 0.8s ease-out;
        }
        .animate-fade-in {
          animation: fade-in 0.8s ease-out;
        }
      `}</style>
    </div>

    <div className="max-w-7xl mx-auto px-4 py-10">
                            <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Discover More Ads</h1>
                      
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                              {/* Card 1 */}
                              <Link to="/gamification/samsung" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                                <img
                                  src="/assets/sama.jpg"
                                  alt="Card 1"
                                  className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                                />
                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                                  <h2 className="text-lg font-semibold">Samsung</h2>
                                </div>
                              </Link>
                      
                              {/* Card 2 */}
                              <Link to="/video/mollers" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                                <img
                                  src="/assets/moll.avif"
                                  alt="Card 2"
                                  className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                                />
                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                                  <h2 className="text-lg font-semibold">Mollers</h2>
                                </div>
                              </Link>
                      
                              {/* Card 3 */}
                              <Link to="/tiger" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                                <img
                                  src="/assets/tiger.avif"
                                  alt="Card 3"
                                  className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                                />
                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                                  <h2 className="text-lg font-semibold">Tiger</h2>
                                </div>
                              </Link>
                      
                              {/* Card 4 */}
                              <Link to="/drag-to-reveal/abcbeer" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                                <img
                                  src="/assets/ab.avif"
                                  alt="Card 4"
                                  className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                                />
                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                                  <h2 className="text-lg font-semibold">ABC Beer</h2>
                                </div>
                              </Link>
                      
                             
                            </div>
                          </div>
    </>
  );
}

export default App;

// import React, { useState, useEffect } from 'react';

// const PerfectSpinWheel = ({ isDesktop = false }) => {
//   const [isSpinning, setIsSpinning] = useState(false);
//   const [rotation, setRotation] = useState(0);
//   const [winner, setWinner] = useState(null);
//   const [showConfetti, setShowConfetti] = useState(false);

//   const segments = [
//     { id: 1, text: "₹500", subText: "Voucher", color: "#3B82F6", textColor: "#fff" },
//     { id: 2, text: "30% OFF", subText: "Skincare", color: "#8B5CF6", textColor: "#fff" },
//     { id: 3, text: "₹100", subText: "Cashback", color: "#10B981", textColor: "#fff" },
//     { id: 4, text: "Free", subText: "Shipping", color: "#F59E0B", textColor: "#fff" },
//     { id: 5, text: "50% OFF", subText: "Beauty", color: "#EF4444", textColor: "#fff" },
//     { id: 6, text: "₹200", subText: "Discount", color: "#EC4899", textColor: "#fff" },
//     { id: 7, text: "Buy 1", subText: "Get 1 Free", color: "#06B6D4", textColor: "#fff" },
//     { id: 8, text: "Try Again", subText: "Next Time", color: "#6B7280", textColor: "#fff" }
//   ];

//   const spinWheel = () => {
//     if (isSpinning) return;
    
//     setIsSpinning(true);
//     setWinner(null);
//     setShowConfetti(false);
    
//     const minSpins = 5;
//     const maxSpins = 8;
//     const spins = minSpins + Math.random() * (maxSpins - minSpins);
//     const finalAngle = Math.random() * 360;
//     const totalRotation = rotation + (spins * 360) + finalAngle;
    
//     setRotation(totalRotation);
    
//     setTimeout(() => {
//       const normalizedAngle = (totalRotation % 360);
//       const segmentAngle = 45; // 360/8 segments
//       const adjustedAngle = (90 - normalizedAngle + 360) % 360; // Adjust for pointer at top
//       const segmentIndex = Math.floor(adjustedAngle / segmentAngle);
//       const winningSegment = segments[segmentIndex] || segments[0];
      
//       setWinner(winningSegment);
//       setIsSpinning(false);
      
//       if (winningSegment.text !== "Try Again") {
//         setShowConfetti(true);
//         setTimeout(() => setShowConfetti(false), 3000);
//       }
//     }, 4000);
//   };

//   const resetWheel = () => {
//     setWinner(null);
//     setIsSpinning(false);
//     setShowConfetti(false);
//   };

//   const claimPrize = () => {
//     alert(`🎉 Congratulations! You've won: ${winner.text} ${winner.subText}!`);
//     resetWheel();
//   };

//   const wheelSize = isDesktop ? 300 : 250;
//   const centerSize = isDesktop ? 60 : 50;

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4 relative overflow-hidden">
//         <div 
//   className="absolute inset-0 opacity-30"
//   style={{
//     backgroundImage: `url('/assets/mam11.jpg')`,
//     backgroundSize: 'cover',
//     backgroundPosition: 'center'
//   }}></div>
//       {/* Confetti Animation */}
//       {showConfetti && (
//         <div className="fixed inset-0 pointer-events-none z-50">
//           {[...Array(30)].map((_, i) => (
//             <div
//               key={i}
//               className="absolute w-2 h-2 rounded-full animate-bounce"
//               style={{
//                 backgroundColor: segments[i % segments.length].color,
//                 left: `${Math.random() * 100}%`,
//                 top: `${Math.random() * 100}%`,
//                 animationDelay: `${Math.random() * 2}s`,
//                 animationDuration: `${2 + Math.random() * 2}s`
//               }}
//             />
//           ))}
//         </div>
//       )}

//       <div className="relative z-10 text-center">
//         {/* Header */}
//         <div className="mb-1">
         
          
//           <h1 className={`${isDesktop ? 'text-4xl' : 'text-3xl'} font-bold text-white mb-1 drop-shadow-lg`}>
//             🎯 SPIN TO WIN 🎯
//           </h1>
//           <p className={`${isDesktop ? 'text-lg' : 'text-base'} text-white opacity-90`}>
//             Try your luck and win amazing prizes!
//           </p>
//         </div>

//         {/* Wheel Container */}
//         <div className="relative inline-block mb-2">
//           {/* Wheel Shadow */}
//           <div 
//             className="absolute top-2 left-2 rounded-full bg-black opacity-30 blur-lg"
//             style={{ width: wheelSize, height: wheelSize }}
//           />
          
//           {/* Outer Orange Ring */}
//           <div 
//             className="rounded-full bg-gradient-to-br from-orange-400 to-orange-500 shadow-2xl relative"
//             style={{ width: wheelSize + 20, height: wheelSize + 20 }}
//           >
//             {/* White Dots Around the Ring */}
//             {[...Array(16)].map((_, i) => (
//               <div
//                 key={i}
//                 className="absolute w-3 h-3 bg-white rounded-full shadow-sm"
//                 style={{
//                   top: '8px',
//                   left: '50%',
//                   transform: `translateX(-50%) rotate(${i * 22.5}deg) translateY(6px)`,
//                   transformOrigin: `50% ${(wheelSize + 20 - 16) / 2}px`
//                 }}
//               />
//             ))}
            
//             {/* Main Wheel */}
//             <div
//               className="absolute top-2.5 left-2.5 w-full h-full rounded-full overflow-hidden transition-transform ease-out"
//               style={{
//                 width: wheelSize,
//                 height: wheelSize,
//                 transform: `rotate(${rotation}deg)`,
//                 transitionDuration: isSpinning ? '4000ms' : '0ms',
//                 transitionTimingFunction: isSpinning ? 'cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'ease'
//               }}
//             >
//               <svg 
//                 width={wheelSize} 
//                 height={wheelSize} 
//                 className="absolute inset-0"
//                 viewBox={`0 0 ${wheelSize} ${wheelSize}`}
//               >
//                 {segments.map((segment, index) => {
//                   const centerX = wheelSize / 2;
//                   const centerY = wheelSize / 2;
//                   const radius = wheelSize / 2 - 5;
//                   const segmentAngle = 45; // 360/8 segments
//                   const startAngle = index * segmentAngle;
//                   const endAngle = (index + 1) * segmentAngle;
//                   const midAngle = startAngle + segmentAngle / 2;
                  
//                   // Calculate path coordinates
//                   const x1 = centerX + radius * Math.cos((startAngle * Math.PI) / 180);
//                   const y1 = centerY + radius * Math.sin((startAngle * Math.PI) / 180);
//                   const x2 = centerX + radius * Math.cos((endAngle * Math.PI) / 180);
//                   const y2 = centerY + radius * Math.sin((endAngle * Math.PI) / 180);
                  
//                   // Text positioning
//                   const textRadius = radius * 0.65;
//                   const textX = centerX + textRadius * Math.cos((midAngle * Math.PI) / 180);
//                   const textY = centerY + textRadius * Math.sin((midAngle * Math.PI) / 180);
                  
//                   return (
//                     <g key={segment.id}>
//                       {/* Segment Background */}
//                       <path
//                         d={`M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 0 1 ${x2} ${y2} Z`}
//                         fill={segment.color}
//                         stroke="#fff"
//                         strokeWidth="2"
//                       />
                      
//                       {/* Main Text */}
//                       <text
//                         x={textX}
//                         y={textY - 3}
//                         textAnchor="middle"
//                         dominantBaseline="middle"
//                         fill={segment.textColor}
//                         fontSize={isDesktop ? "16" : "13"}
//                         fontWeight="bold"
//                         transform={`rotate(${midAngle + 90}, ${textX}, ${textY})`}
//                       >
//                         {segment.text}
//                       </text>
                      
//                       {/* Sub Text */}
//                       <text
//                         x={textX}
//                         y={textY + 10}
//                         textAnchor="middle"
//                         dominantBaseline="middle"
//                         fill={segment.textColor}
//                         fontSize={isDesktop ? "11" : "9"}
//                         fontWeight="500"
//                         transform={`rotate(${midAngle + 90}, ${textX}, ${textY})`}
//                       >
//                         {segment.subText}
//                       </text>
//                     </g>
//                   );
//                 })}
//               </svg>
              
//               {/* Center Circle */}
//               <div 
//                 className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gradient-to-br from-orange-400 to-orange-500 rounded-full shadow-lg border-4 border-white flex items-center justify-center"
//                 style={{ width: centerSize, height: centerSize }}
//               >
//                 <div className="w-6 h-6 bg-gradient-to-br from-red-500 to-red-600 rounded-full flex items-center justify-center">
//                   <span className="text-white font-bold text-sm">⭐</span>
//                 </div>
//               </div>
//             </div>
            
//             {/* Pointer */}
//             <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1 z-20">
//               <div className="w-0 h-0 border-l-4 border-r-4 border-b-8 border-l-transparent border-r-transparent border-b-red-500 drop-shadow-lg"></div>
//               <div className="absolute top-2 left-1/2 transform -translate-x-1/2 w-4 h-4 bg-red-500 rounded-full border-2 border-white shadow-lg"></div>
//             </div>
//           </div>
//         </div>

//         {/* Controls */}
//         {!isSpinning && !winner && (
//           <div className="space-y-4">
//             <button
//               onClick={spinWheel}
//               className={`bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-400 hover:to-red-400 text-white font-bold ${isDesktop ? 'py-3 px-10 text-xl' : 'py-2 px-8 text-lg'} rounded-full transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-xl`}
//             >
//               🎰 SPIN THE WHEEL 🎰
//             </button>
//             <p className={`${isDesktop ? 'text-base' : 'text-sm'} text-white opacity-80`}>
//               Click to spin and win amazing prizes!
//             </p>
//           </div>
//         )}

//         {/* Spinning Animation */}
//         {isSpinning && (
//           <div className="space-y-4">
//             <div className={`${isDesktop ? 'text-2xl' : 'text-xl'} font-bold text-white animate-pulse`}>
//               🌟 SPINNING... 🌟
//             </div>
//             <div className="flex justify-center space-x-2">
//               {[...Array(3)].map((_, i) => (
//                 <div
//                   key={i}
//                   className="w-3 h-3 bg-white rounded-full animate-bounce"
//                   style={{ animationDelay: `${i * 0.2}s` }}
//                 />
//               ))}
//             </div>
//             <p className={`${isDesktop ? 'text-lg' : 'text-base'} text-white opacity-80`}>
//               Good luck! 🍀
//             </p>
//           </div>
//         )}

//         {/* Winner Display */}
//         {winner && !isSpinning && (
//           <div className="animate-fadeIn">
//             <div className="bg-white bg-opacity-20 backdrop-blur-lg rounded-xl p-2 shadow-2xl border border-white border-opacity-30 relative max-w-sm mx-auto">
//               <button
//                 onClick={resetWheel}
//                 className="absolute top-2 right-2 w-7 h-7 bg-red-500 hover:bg-red-600 text-white rounded-full flex items-center justify-center transition-all duration-300 text-sm"
//               >
//                 ✕
//               </button>
              
//               <div className="text-4xl mb-1">
//                 {winner.text === "Try Again" ? "🌟" : "🎉"}
//               </div>
              
//               <h2 className={`${isDesktop ? 'text-2xl' : 'text-xl'} font-bold text-white mb-1`}>
//                 {winner.text === "Try Again" ? "Almost There!" : "CONGRATULATIONS!"}
//               </h2>
              
//               {winner.text !== "Try Again" ? (
//                 <div className="space-y-3">
//                   <div
//                     className="inline-block px-4 py-2 rounded-full text-white font-bold shadow-lg"
//                     style={{ backgroundColor: winner.color }}
//                   >
//                     {winner.text} {winner.subText}
//                   </div>
//                   <p className="text-white text-sm opacity-90">
//                     Your prize is ready!
//                   </p>
//                 </div>
//               ) : (
//                 <div className="space-y-3">
//                   <p className="text-white text-sm opacity-90">
//                     Try again for better luck!
//                   </p>
//                 </div>
//               )}
              
//               <div className="flex gap-3 justify-center mt-2">
//                 <button
//                   onClick={resetWheel}
//                   className="bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-400 hover:to-purple-400 text-white font-bold py-2 px-4 rounded-full transition-all duration-300 text-sm"
//                 >
//                   Spin Again
//                 </button>
//                 {winner.text !== "Try Again" && (
//                   <button
//                     onClick={claimPrize}
//                     className="bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-400 hover:to-emerald-400 text-white font-bold py-2 px-4 rounded-full transition-all duration-300 text-sm"
//                   >
//                     Claim Prize
//                   </button>
//                 )}
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       <style jsx>{`
//         @keyframes fadeIn {
//           from { opacity: 0; transform: translateY(20px); }
//           to { opacity: 1; transform: translateY(0); }
//         }
//         .animate-fadeIn {
//           animation: fadeIn 0.6s ease-out;
//         }
//       `}</style>
//     </div>
//   );
// };

// const PhoneMockup = () => {
//   return (
//     <div className="relative">
//       <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-[2.5rem] p-2 shadow-2xl border-4 border-slate-700">
//         <div className="bg-black rounded-[2rem] p-1">
//           <div className="w-[280px] h-[700px] bg-white rounded-[1.5rem] overflow-hidden relative shadow-inner">
//             {/* Phone Status Bar */}
//             <div className="absolute top-2 left-4 right-4 flex justify-between items-center z-40 text-white text-xs font-medium">
//               <span>9:41</span>
//               <div className="flex items-center space-x-1">
//                 <div className="flex space-x-1">
//                   <div className="w-1 h-1 bg-white rounded-full"></div>
//                   <div className="w-1 h-1 bg-white rounded-full"></div>
//                   <div className="w-1 h-1 bg-white rounded-full"></div>
//                 </div>
//                 <div className="w-6 h-3 border border-white rounded-sm">
//                   <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
//                 </div>
//               </div>
//             </div>
            
//             {/* Home Indicator */}
//             <div className="absolute bottom-1 left-1/2 transform -translate-x-1/2 w-20 h-1 bg-gray-300 rounded-full z-40"></div>
            
//             <div className="w-full h-full">
//               <PerfectSpinWheel isDesktop={false} />
//             </div>
//           </div>
//         </div>
//       </div>
      
//       {/* Phone Reflection */}
//       <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white to-transparent opacity-10 rounded-[2.5rem] pointer-events-none"></div>
//     </div>
//   );
// };

// const DesktopMockup = () => {
//   return (
//     <div className="relative">
//       <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-4 shadow-2xl border-4 border-slate-700">
//         <div className="bg-black rounded-xl p-2">
//           <div className="w-[800px] h-[700px] bg-white rounded-lg overflow-hidden relative shadow-inner">
//             {/* Browser Header */}
//             <div className="absolute top-0 left-0 right-0 h-10 bg-gray-100 border-b border-gray-300 flex items-center px-4 z-40">
//               <div className="flex space-x-2">
//                 <div className="w-3 h-3 bg-red-500 rounded-full"></div>
//                 <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
//                 <div className="w-3 h-3 bg-green-500 rounded-full"></div>
//               </div>
//               <div className="flex-1 mx-4">
//                 <div className="bg-white rounded px-3 py-1 text-xs text-gray-600 border">
//                   https://mamaearth.in/spin-to-win
//                 </div>
//               </div>
//               <div className="flex space-x-2">
//                 <div className="w-4 h-4 bg-gray-300 rounded"></div>
//                 <div className="w-4 h-4 bg-gray-300 rounded"></div>
//               </div>
//             </div>
//             <div className="w-full h-full pt-10">
//               <PerfectSpinWheel isDesktop={true} />
//             </div>
//           </div>
//         </div>
        
//         {/* Desktop Stand */}
//         <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-4">
//           <div className="w-32 h-6 bg-gradient-to-b from-slate-600 to-slate-800 rounded-b-lg shadow-lg"></div>
//           <div className="w-48 h-3 bg-gradient-to-b from-slate-700 to-slate-900 rounded-full mx-auto shadow-lg"></div>
//         </div>
//       </div>
      
//       {/* Desktop Reflection */}
//       <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white to-transparent opacity-10 rounded-2xl pointer-events-none"></div>
//     </div>
//   );
// };

// const ResponsiveSpinWheel = () => {
//   return (
//     <div className="mt-14 min-h-screen bg-gradient-to-br from-indigo-900 via-purple-900 to-pink-900 p-8">
//       {/* Title */}
//       <div className="text-center mb-8">
//         <h1 className="text-4xl font-bold text-white mb-2">
//           🎯 Spin to Win - Device Mockups 🎯
//         </h1>
//         <p className="text-white/80 text-lg">
//           Experience the thrill across all devices
//         </p>
//       </div>

//       {/* Mobile Only View */}
//       <div className="lg:hidden flex flex-col items-center justify-center min-h-screen">
//         <div className="mb-6">
//           <h3 className="text-white text-xl font-bold mb-4 text-center">Mobile Experience</h3>
//           <PhoneMockup />
//         </div>
//       </div>
      
//       {/* Desktop Only View */}
//       <div className="hidden lg:flex lg:flex-col xl:hidden items-center justify-center min-h-screen">
//         <div className="mb-6">
//           <h3 className="text-white text-2xl font-bold mb-6 text-center">Desktop Experience</h3>
//           <DesktopMockup />
//         </div>
//       </div>
      
//       {/* Both Views for Comparison (visible on xl screens) */}
//       <div className="hidden xl:flex xl:flex-row xl:space-x-12 xl:items-center xl:justify-center xl:min-h-screen xl:py-12">
//         <div className="flex flex-col items-center">
//           <h3 className="text-white text-2xl font-bold mb-6">Desktop Experience</h3>
//           <DesktopMockup />
//         </div>
//         <div className="flex flex-col items-center">
//           <h3 className="text-white text-2xl font-bold mb-6">Mobile Experience</h3>
//           <PhoneMockup />
//         </div>
//       </div>
      
//       {/* Features Section */}
//       <div className="mt-12 max-w-4xl mx-auto">
//         <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8">
//           <h2 className="text-2xl font-bold text-white mb-6 text-center">🌟 Key Features</h2>
//           <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
//             <div className="bg-white/10 rounded-xl p-4 text-center">
//               <div className="text-3xl mb-2">🎰</div>
//               <h3 className="text-white font-bold mb-2">Smooth Spinning</h3>
//               <p className="text-white/80 text-sm">Physics-based rotation with realistic easing</p>
//             </div>
//             <div className="bg-white/10 rounded-xl p-4 text-center">
//               <div className="text-3xl mb-2">🎉</div>
//               <h3 className="text-white font-bold mb-2">Confetti Effects</h3>
//               <p className="text-white/80 text-sm">Celebration animations for winners</p>
//             </div>
//             <div className="bg-white/10 rounded-xl p-4 text-center">
//               <div className="text-3xl mb-2">📱</div>
//               <h3 className="text-white font-bold mb-2">Responsive Design</h3>
//               <p className="text-white/80 text-sm">Perfect on all devices and screen sizes</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ResponsiveSpinWheel;
